import React, { useState, useCallback } from "react";
import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import {
  Typography,
  Stack,
  Box,
  FormControlLabel,
  Checkbox,
  Button,
  ButtonBase,
  GlobalStyles,
  Divider,
  TextField,
  Avatar,
  FormControl, 
  Input, 
  InputLabel,
  InputAdornment,
  Fade
} from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import MobileHero from "src/public/assets/illustrations/mobileHero.png";


import NameIcon from "src/public/assets/illustrations/name.png";
import EmailIcon from "src/public/assets/illustrations/email.png";
import PasswordIcon from "src/public/assets/illustrations/password.png";
import ConfirmPasswordIcon from "src/public/assets/illustrations/confirmPassword.png";
import IconTextField from "./components/mobile/IconTextField";
import IconNameField from "./components/mobile/IconNameField";

import mobileBackground from "src/public/assets/illustrations/mobileBackground.png"
 import SignUpCompleteIcon from "src/public/assets/illustrations/signupComplete.png";



/* ---------- layout wrapper ---------- */
const StyledRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  maxWidth: "100vw",
  height: "100svh", // << Use svh for accurate mobile height
  overflow: "hidden",
  fontFamily: "'Lato', sans-serif",
padding: "4vh 0",
  boxSizing: "border-box",
  justifyContent: 'center',
  backgroundColor: '#F7FBFC',
  backgroundImage: `url(${mobileBackground})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
});



export default function SignupMobile({handleSubmit,
submitTick,
errors,
setErrors,
validate,
showErrors,
setShowErrors,
firstName,
setFirstName,
lastName,
setLastName,
email,
setEmail,
password,
setPassword,
confirmPassword,
setConfirmPassword,
handleFirstNameChange,
handleLastNameChange,
handleEmailChange,
handlePasswordChange,
handleConfirmPasswordChange,
showPassword,
setShowPassword,
showConfirmPassword,
setShowConfirmPassword,
handleTogglePassword,
handleToggleConfirmPassword,
loading,
setLoading,
complete

}) {

    const ADORN_WIDTH = 46; // px – tune if you change icon size/gap


    const auth0LoginUrl =
  "https://dev-4m53d4wv8p6pmod8.us.auth0.com/u/login";










  return (
    <>
      {/* global reset so the body itself cannot create overflow */}
      <GlobalStyles styles={{ body: { margin: 0 } }} />

      <Helmet>
        <title>SignUp | NanoNotify.io</title>
        <link
          href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <StyledRoot>
        {/* ---------- hero & heading ---------- */}
        <Stack
          alignItems="center"
          spacing={0.5}
          sx={{

            px: { xs: 2, sm: 4, md: 6 }, // responsive horizontal gutters
            textAlign: "center",
            width: "100%",
            boxSizing: "border-box",
            mt:-2
     
          }}
        >
<img
  src={complete ? SignUpCompleteIcon : MobileHero}
  alt=""
  style={{
    height: complete ? '120px' : '80px',
    width: 'auto',
    maxWidth: '90%',
    objectFit: 'contain',
  }}
/>
          

          <Typography
            gutterBottom
            sx={{
              fontWeight: 900,
              fontSize: 25,
              color: "#395465",
              letterSpacing: "-0.02em",
                fontFamily: "'Lato', sans-serif",
              

            }}
          >
          { complete ? "You’re all set!"  :   "Get Started" }
          </Typography>

          <Typography
            gutterBottom
            sx={{
              fontWeight: 500,
              fontSize: 15,
              color: "#89A6B4",
              letterSpacing: "-0.02em",
                              fontFamily: "'Lato', sans-serif",
                              px:3,
                              pb:3

            }}
          >
           {complete ? 
              "Your account has been created. Check your email and verify your account"
              :
              "Instantly create your free NanoNotify account"
              }
          </Typography>
        </Stack>

        

        {/* ---------- form wrapper ---------- */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 600,
            mx: "auto",
            px: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            boxSizing: "border-box",
                zIndex: 2,

          }}
        >
          <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
            {/* ---------- Name Field Container---------- */}





{!complete && (
  <>
                  <IconNameField
          id="fullName"
          label="Name"
          placeholderOne="First Name"
          placeholderTwo="Last Name"

          icon={NameIcon}        
          autoComplete="name"
          firstName={firstName}
          lastName={lastName}
          firstNameChange={handleFirstNameChange}
          lastNameChange={handleLastNameChange}
                              errors={errors}   
                    showErrors={showErrors} 
                    submitTick={submitTick} 
                      loading={loading}
        />
      

                        {/* ---------- Email Field Container---------- */}

      <IconTextField
        id="email"
        label="Email"
        placeholder="you@example.com"
        icon={EmailIcon}          // string → rendered inside <Avatar/>
        inputMode="email"
        autoComplete="email"
        avatarVariant="circular"
        onChange={handleEmailChange}
        value={email}
        onClick={null}
                    errors={errors}   
                    showErrors={showErrors} 
                    submitTick={submitTick} 
                    loading={loading}

      />

                        {/* ---------- Password Field Container---------- */}
      <IconTextField
        id="password"
        label="Password"
        placeholder="Enter Account Password"
        icon={PasswordIcon}          // string → rendered inside <Avatar/>
        inputMode="password"
        avatarVariant="circular"
        autoComplete="off"
                showPassword={showPassword}
                onChange={handlePasswordChange}
                value={password}
                onClick={handleTogglePassword}
                                    errors={errors}   
                                    showErrors={showErrors} 
                                                        submitTick={submitTick} 
                                                        loading={loading}



      />



                        {/* ---------- Confirm Password Field Container---------- */}

      <IconTextField
        id="confirmPassword"
        label="Confirm Password"
        placeholder="Confirm Password"
        icon={ConfirmPasswordIcon}          // string → rendered inside <Avatar/>
        inputMode="password"
        avatarVariant="circular"
                autoComplete="off"

                showPassword={showConfirmPassword}
                onChange={handleConfirmPasswordChange}
                value={confirmPassword}
                onClick={handleToggleConfirmPassword}
                                    errors={errors}  
                                    showErrors={showErrors}  
                                                        submitTick={submitTick} 
                                                        loading={loading}



        
      />
           
</>
)}








            

           

            {/* ---------- submit button ---------- */}

            <Box>
              {errors.generic && (
  <Typography align="center" sx={{ color: '#AA5869', px: 4,  }}>
    Unable to create account.<br />
    Please try again later.
  </Typography>
)}
            <Button
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              disabled={loading}

              sx={{
                mt: 3,
                height: 54,
                backgroundColor: "#FF9490",
                fontSize: 22,
                fontWeight: 900,
                textTransform: "none",
                boxShadow: "6px 9px 19.1px rgba(255, 148, 144, 0.3)",
                borderRadius: 2,
                fontFamily: "'Lato', sans-serif",
                "&:hover": {
                  backgroundColor: "#FF7A7A",
                  boxShadow: "6px 9px 19.1px rgba(255,122,122,.35)",
                },
                "&:active": {
                  backgroundColor: "#FF5F5F",
                  boxShadow: "6px 9px 19.1px rgba(255,95,95,.4)",
                },
                "&:focus": {
                  backgroundColor: "#FF9490",
                  boxShadow: "6px 9px 19.1px rgba(255,148,144,.5)",
                },
              }}
            >
{loading ? "Loading..." : complete ? "Sign In" : "Sign Up"}
      </Button>
            </Box>




          </Stack>

        </Box>
      </StyledRoot>
    </>
  );
}
